export default __webpack_public_path__ + "static/media/like.48e59c29.svg";